import script from "./DesktopNavigation.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesktopNavigation.vue?vue&type=script&setup=true&lang=ts"

import "./DesktopNavigation.vue?vue&type=style&index=0&id=188a714a&lang=less"

const __exports__ = script;

export default __exports__